import React from "react";
import Grid from "@material-ui/core/Grid";
import { TextField } from "final-form-material-ui";
import { Field } from "react-final-form";
import { List, CrudForm, ListApi, FormApi } from "elentari";
import { grupoAlimentarApi as api } from "../../services/Api";

export function GruposAlimentaresList(props) {
  const listOptions = {
    defaultOrder: "descricao",
    fields: {
      id: {
        label: "Id",
      },
      descricao: {
        label: "Descrição",
      },
    },
  };

  return (
    <ListApi api={api}>
      {({ getPage, getCount, handleDelete }) => (
        <List
          {...props}
          withPaper
          deleteItem={handleDelete}
          labelNew="Novo"
          onClickEdit={(item) =>
            props.history.push(`/grupos-alimentares/${item.id}`)
          }
          onClickNew={() => props.history.push("/grupos-alimentares/new")}
          getPage={getPage}
          getCount={getCount}
          listOptions={listOptions}
        />
      )}
    </ListApi>
  );
}

export function GruposAlimentaresForm(props) {
  const validate = (values) => ({
    descricao: values.descricao ? undefined : "Obrigatório",
  });

  return (
    <FormApi api={api} {...props}>
      {({ handleSubmit, getItem }) => (
        <CrudForm
          withPaper
          validate={validate}
          history={props.history}
          getItem={getItem}
          onSubmit={handleSubmit}
        >
          <Grid container spacing={16}>
            <Grid item sm>
              <Field
                fullWidth
                autoFocus
                component={TextField}
                label="Descrição"
                name="descricao"
              />
            </Grid>
          </Grid>
        </CrudForm>
      )}
    </FormApi>
  );
}
